import React, { useContext, useState } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { getIsModalOpen, useModalState } from "./../../ricos-modals/modal-service-provider.js";
import { ToolbarButton } from "./../../_shared/toolbar-button/toolbar-button.js";
import { HTML_BUTTONS } from "../consts.js";
const DimensionSliderButton = ({ toolbarItem, dataHook, dimension }) => {
  const [referenceElement, setReferenceElement] = useState(null);
  const { t, isMobile } = useContext(RicosContext) || {};
  const isModalOpen = useModalState(getIsModalOpen(HTML_BUTTONS[dimension]));
  const { icon, tooltip } = toolbarItem.presentation;
  const onClick = () => {
    toolbarItem.commands?.click({ referenceElement, isMobile });
  };
  return /* @__PURE__ */ React.createElement(
    ToolbarButton,
    {
      ref: setReferenceElement,
      active: isModalOpen,
      prefix: icon,
      onClick,
      dataHook,
      tooltip: t(tooltip),
      tabIndex: toolbarItem.presentation.tabIndex
    }
  );
};
export {
  DimensionSliderButton
};
//# sourceMappingURL=DimensionSliderButton.js.map
